<template>
  <div>
    <el-card class="box-card" body-style="min-height:78vh;">
      <div slot="header" class="clearfix">
        <el-button @click="editBtn('')" size="small" type="primary" class="bg-theme">添加门店用户</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="用户账号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="用户昵称">
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="superAdmin"
            label="是否管理员">
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#409EFF"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="changePwdBtn(scope.row.id)" type="text" size="small">修改密码</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="changePwdShow"
      width="960px">
      <el-form :model="changePwdForm" :rules="changePwdRules" label-width="140px">
        <el-form-item label="原密码" prop="oldUserPassword">
          <el-input style="width: 420px;" type="password" v-model="changePwdForm.oldUserPassword" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="userPassword">
          <el-input style="width: 420px;" type="password" v-model="changePwdForm.userPassword" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changePwdSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryShopUserPageList, removeShopUserById, updateShopUserStatus, updateShopUserPassword } from '@/api/shop'
export default {
  name: 'ShopAdmin',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId:'',
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 修改密码弹窗
      changePwdShow:false,
      changePwdForm:{
        oldUserPassword:'',
        userPassword:''
      },
      changePwdRules: {
        oldUserPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 修改密码弹窗-打开弹窗
    changePwdBtn(infoId){
      this.infoId = infoId;
      this.changePwdShow = true;
    },
    // 修改密码弹窗-保存弹窗
    changePwdSaveBtn(){
      var that = this;
      var infoId = that.infoId;
      var changePwdForm = that.changePwdForm;
      if(changePwdForm.oldUserPassword == ''){
        this.$message.error('请输入原密码')
        return false
      }
      if(changePwdForm.userPassword == ''){
        this.$message.error('请输入新密码')
        return false
      }
      if (changePwdForm.oldUserPassword === changePwdForm.userPassword) {
        this.$message.error('新密码和旧密码需要不一致！')
        return false
      }
      updateShopUserPassword({id:infoId,oldUserPassword:changePwdForm.oldUserPassword,userPassword:changePwdForm.userPassword}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.$message.success(res.msg);
          that.getInfoList();
          that.changePwdShow = false;
          that.changeMoneyForm.oldUserPassword = '';
          that.changeMoneyForm.userPassword = '';
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let name = that.searchForm.name
      let page = that.currentPage
      queryShopUserPageList({ nickName: name,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item) {
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/shop_admin_add', query: {dataId: infoId}})
    },
    // 开启或禁用操作
    switchChangeBtn (infoId) {
      let that = this
      updateShopUserStatus({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeShopUserById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/shop/admin/List.vue